import React from 'react';
import PropTypes from 'prop-types';
import Classes from '../Classes';
import { FavouriteConstants } from '../Constants';

const FollowIcon = ({ isFollowed, altSVG }) => (
  <svg
    width="18px"
    height="25px"
    viewBox="0 0 25 23"
    aria-labelledby="uniqueDescID"
    role="img"
    className={Classes.genericIcon}
  >
    <desc id="uniqueDescID">{altSVG}</desc>
    {isFollowed ?
      <g>
        <path className={Classes.favSelectFill} d={FavouriteConstants.favouriteIconUnSelectedPath2} />
      </g>
            :
      <g>
        <path className={Classes.favSelectFill} d={FavouriteConstants.favouriteIconUnSelectedPath1} />
      </g>
        }
  </svg>);

FollowIcon.propTypes = {
  isFollowed: PropTypes.bool.isRequired,
  altSVG: PropTypes.string.isRequired
};

export default FollowIcon;
